import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "appSurvey" */ './AppSurvey')));

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'AppSurvey');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as AppSurvey };
